import React from 'react';

const TopBar = () => {
  return (
    <div className="top-bar">
      <div className="top-bar-container">
        <div className="top-bar-contact">
          <span className="contact-item">
            <i className="fas fa-map-marker-alt"></i>
            Patna-Muzaffarpur-Motihari-Siwan-Gopalganj-Purnia-Bhagalpur-Farbisganj-Kusinagar-Darbhanga
          </span>
          <span className="contact-item">
            <i className="fas fa-phone-alt"></i>
            +91 99397 65562
          </span>
          <span className="contact-item">
            <i className="fas fa-envelope"></i>
            info@drdsntoshkumar.co.in
          </span>
        </div>
        <div className="top-bar-social">
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a>
          <a href="http://instagram.com/uttamdiabetescare/" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
          <a href="https://www.youtube.com/@UttamDiabetesCare/" target="_blank" rel="noopener noreferrer"><i className="fab fa-youtube"></i></a>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
